import React from 'react';
import { Button, Container, Typography, Box } from '@mui/material';
import { useChildContext } from '../contexts/ChildContext';
import useChildName from '../hooks/useChildName';
import CareLibrarySection from '../features/careSourceProcessing/CareLibrarySection';
import { useNavigate, useSearchParams } from 'react-router-dom';
import ChildShellBottomNav from '../components/Dashboard/shared/ChildShellBottomNav';
import { navigateFromDocumentLibrary } from '../features/careSourceProcessing/documentLibraryNavigation';

const TemplateLibraryPage = () => {
  const { currentChildId } = useChildContext();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { childName, loading, error } = useChildName(currentChildId);

  if (loading) {
    return <Typography>Loading...</Typography>;
  }

  if (error) {
    return <Typography>Error: {error.message}</Typography>;
  }

  if (!currentChildId) {
    return (
      <Typography>
        No child selected. Please select a child from the dashboard.
      </Typography>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: { xs: 11, md: 4 } }}>
      <Button onClick={() => navigate('/home')} sx={{ px: 0, textTransform: 'none' }}>← Home</Button>
      <Box sx={{ mb: 2.25 }}>
        <Typography variant="h4" gutterBottom>
          {childName ? `${childName}'s Library` : 'Library'}
        </Typography>
        <Typography sx={{ color: 'text.secondary', maxWidth: 720 }}>
          Saved care sources stay searchable here by file type, source record, and subject.
        </Typography>
      </Box>

      <CareLibrarySection childId={currentChildId} initialViewMode={searchParams.get('tab') || 'all'} />
      <Box sx={{ display: { xs: 'block', md: 'none' } }}><ChildShellBottomNav activeItem="" onSelect={(itemId) => navigateFromDocumentLibrary({ navigate, childId: currentChildId, itemId })} /></Box>
    </Container>
  );
};

export default TemplateLibraryPage;
